import React from "react"
import { BsMoon, BsSun } from "react-icons/bs"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

type Props = {
  darkMode: boolean
  collapsed: boolean
  onDarkModeChange: (dark: boolean) => void
}

export const SidebarThemeToggle = ({ darkMode, collapsed, onDarkModeChange }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <div
      className={clsx(
        "mt-8 p-[2px] text-xs rounded-lg z-10",
        collapsed ? "flex flex-col gap-2" : "flex items-center justify-between",
        darkMode ? "bg-[#1E1F2B] border border-transparent" : "bg-white border border-[rgba(132,0,168,0.6)]"
      )}
    >
      <button
        className={clsx("flex items-center justify-center gap-2 px-2 py-1 w-full rounded", !darkMode ? "bg-[#8400A8] text-white" : "")}
        onClick={() => onDarkModeChange(false)}
        title={collapsed ? t("settings.light") : undefined}
        type="button"
      >
        <BsSun /> {!collapsed && t("settings.light")}
      </button>

      <button
        className={clsx(
          "flex items-center justify-center gap-2 px-2 py-1 w-full rounded",
          darkMode ? "bg-[#131421] text-white" : "text-[#5E6877]"
        )}
        onClick={() => onDarkModeChange(true)}
        title={collapsed ? t("settings.dark") : undefined}
        type="button"
      >
        <BsMoon /> {!collapsed && t("settings.dark")}
      </button>
    </div>
  )
}
